<template>
  <v-container fluid>
    <h2 class="mb-5">{{ $t('myCommunities') }}</h2>
    <ClubModule/>
    <v-divider class="my-5"/>
    <h2 class="my-5">{{ $t('sharedJournal') }}</h2>
    <SharingModule/>
  </v-container>
</template>

<script>
import SharingModule from "@/views/Community/SharingModule";
import ClubModule from "@/views/Community/ClubModule";

export default {
  name: "CommunityIndex",
  components: {ClubModule, SharingModule},
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en":{
    "myCommunities": "My Communities",
    "sharedJournal": "My Shared Journal"

  },
  "es":{
    "myCommunities": "Mis Comunidades",
    "sharedJournal": "Mi Bitácora Compartida"
  }
}
</i18n>
